import React from 'react';
import { Link } from 'react-router-dom';

// Botón grande de "acceso rápido" a una sección del aula virtual.
// Usa un ícono + color en vez de fotos, para que cargue rápido y se vea igual
// de bien sin depender de imágenes externas.
const QuickAccessCard = ({ icono, color, titulo, descripcion, link }) => {
  return (
    <Link to={link} className="card h-100 text-decoration-none av-quick-card">
      <div className="card-body d-flex align-items-start">
        <div
          className="av-quick-icon me-3 flex-shrink-0"
          style={{ backgroundColor: `${color}1a`, color }}
        >
          <i className={`fas ${icono}`} aria-hidden="true"></i>
        </div>
        <div>
          <h5 className="card-title text-body mb-1">{titulo}</h5>
          <p className="card-text text-muted mb-0">{descripcion}</p>
        </div>
      </div>
    </Link>
  );
};

export default QuickAccessCard;
